import { Dispatch } from 'redux'
import { Store } from '@reduxjs/toolkit'

import * as ApprovalActions from '../actions/approval.action'
import { IService } from '../../shared/interfaces/service.interface'
import { IApprovalAction } from '../../shared/interfaces/action.interface'
import { IAppState } from '../reducers'
import { IApprovalItem, IApprovalsFetchResponse } from '../../shared/interfaces/approval.interface'

const fetchApprovals =
  ({ log, api }: IService) =>
  ({ dispatch }: Store<IAppState>) =>
  (next: Dispatch) =>
  async (action: IApprovalAction) => {
    next(action)
    const { type, payload } = action

    if (type === ApprovalActions.APPROVAL_FETCH_APPLICATIONS) {
      try {
        const { data, success, errors }: IApprovalsFetchResponse = await api.approval.fetch(
          null,
          payload,
        )

        if (success) {
          dispatch(ApprovalActions.ApprovalFetchApplicationsSuccess(data))
        } else {
          dispatch(ApprovalActions.ApprovalFetchApplicationsError())
        }
      } catch (error: any) {
        log(error)
      }
    }
  }

const fetchApproval =
  ({ log, api }: IService) =>
  ({ dispatch, getState }: Store<IAppState>) =>
  (next: Dispatch) =>
  async (action: IApprovalAction) => {
    next(action)
    const { type, payload } = action

    if (type === ApprovalActions.APPROVAL_FETCH_APPLICATION) {
      const {
        approval: { list },
      } = getState()

      // Check if approval list is not empty
      if (list || list.items.length === 0) {
        // Get updated list
        const { data, success, errors }: IApprovalsFetchResponse = await api.approval.fetch(
          null,
          payload,
        )

        if (success) {
          // Find index of specific application using slug
          const idx: any = data.items.findIndex((item: IApprovalItem) => item.slug == payload.q)

          // Update approval list
          dispatch(ApprovalActions.ApprovalFetchApplicationsSuccess(data))

          // Set selected application
          dispatch(ApprovalActions.ApprovalFetchApplicationSuccess(data.items[idx]))
        } else {
          dispatch(ApprovalActions.ApprovalFetchApplicationsError())
        }
      } else {
        // Find index of specific application using slug
        const idx: any = list.items.findIndex((item: IApprovalItem) => item.slug == payload.q)

        if (idx > -1) {
          // Set selected application
          dispatch(ApprovalActions.ApprovalFetchApplicationSuccess(list.items[idx]))
        }
      }
    }
  }

const approval = [fetchApprovals, fetchApproval]

export default approval
